import { createSlice } from "@reduxjs/toolkit";

const defaultParts = {
  products: [],
  totalQuantity: 0,
};

const sparePartsSlice = createSlice({
  name: "dongle",
  initialState: defaultParts,
  reducers: {
    addProduct(state, action) {
      const newProduct = action.payload;
      const existingCartItem = state.products.find(
        (item) => item.id === newProduct.id
      );

      const existingCartName = state.products.find(
        (title) => title.title === newProduct.title
      );
      if (!existingCartItem && !existingCartName) {
        state.products.push({
          id: newProduct.id,
          title: newProduct.title,
          image: newProduct.image,
          price: newProduct.price,
          quantity: newProduct.quantity,
        });
      } else {
        existingCartItem.quantity = existingCartItem.quantity + 1;
      }
      state.totalQuantity = state.totalQuantity + newProduct.quantity;
    },
    removeProduct(state, action) {
      const id = action.payload;
      const existingCartItem = state.products.find((item) => item.id === id);
      state.totalQuantity = state.totalQuantity - 1;
      if (existingCartItem.quantity === 1) {
        state.products = state.products.filter((item) => item.id !== id);
      } else {
        existingCartItem.quantity = existingCartItem.quantity - 1;
      }
    },

    clearCart(state) {
      state.products = [];
      state.totalQuantity = 0;
    },
  },
});

export const partsActions = sparePartsSlice.actions;
export default sparePartsSlice;
